/**
 * ExpandIcon Component
 * Reusable expand/collapse icon for accordion functionality
 * Uses SVG with CSS animation for smooth rotation
 */

import React from 'react';
import { ChevronRight } from 'lucide-react';

export interface ExpandIconProps {
  isExpanded: boolean;
  className?: string;
  size?: number;
}

/**
 * ExpandIcon component - SVG chevron with animated rotation
 */
export const ExpandIcon: React.FC<ExpandIconProps> = ({
  isExpanded,
  className = '',
  size = 14
}) => {
  return (
    <span
      className={`detail-expand-icon ${className}`}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        transform: isExpanded ? 'rotate(90deg)' : 'rotate(0deg)',
        transition: 'transform 0.2s ease'
      }}
    >
      <ChevronRight size={size} />
    </span>
  );
};

export default ExpandIcon;